var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccountsFill = function SvgAccountsFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11q1.25 0 2.125-.875A2.9 2.9 0 0 0 17 8q0-1.25-.875-2.125A2.9 2.9 0 0 0 14 5q-1.25 0-2.125.875A2.9 2.9 0 0 0 11 8q0 1.25.875 2.125A2.9 2.9 0 0 0 14 11m-6 7q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 16V4q0-.824.588-1.412A1.93 1.93 0 0 1 8 2h12q.824 0 1.413.587Q22 3.176 22 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm-4 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 20V7q0-.424.288-.713A.97.97 0 0 1 3 6q.424 0 .712.287Q4 6.576 4 7v13h13q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 17 22zm4-6h12a7.2 7.2 0 0 0-2.637-2.213A7.5 7.5 0 0 0 14 13a7.5 7.5 0 0 0-3.363.787A7.2 7.2 0 0 0 8 16"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccountsFill);
export { ForwardRef as ReactComponent };